import Vue from 'vue';
import VueRouter from 'vue-router';
import store from 'store';
Vue.use(VueRouter);

function load(path, type = 0) {
  const dir = type ? 'components' : 'views';
  return () => import(`@/${dir}/${path}.vue`);
}

const Router = new VueRouter({
  routes: [
    {
      path: '/',
      name: 'home',
      component: load('home'),
    },
    {
      path: '/login',
      name: 'login',
      component: load('login'),
    },
    {
      path: '/third/index',
      name: 'center',
      component: load('third/center'),
    },
    {
      path: '/third',
      component: load('third'),
      props: true,
      children: [
        {
          path: ':id/home',
          props: true,
          component: load('third/home'),
        },
        {
          path: ':id/custom',
          component: load('third/custom'),
          props: true,
          redirect: ':id/custom/index',
          children: [
            {
              path: 'index',
              props: true,
              component: load('third/custom/index'),
            },
          ],
        },
        {
          path: ':id/tag',
          component: load('third/tag'),
          props: true,
          redirect: ':id/tag/index',
          children: [
            {
              path: 'index',
              props: true,
              component: load('third/tag/index'),
            },
            {
              path: 'list',
              props: true,
              component: load('third/tag/list'),
            },
          ],
        },
        {
          path: ':id/mass',
          component: load('third/mass'),
          props: true,
          redirect: ':id/mass/index',
          children: [
            {
              path: 'index',
              props: true,
              component: load('third/mass/index'),
            },
            {
              path: 'index/creat',
              props: true,
              component: load('third/mass/message'),
            },
            {
              path: 'index/edit',
              props: true,
              component: load('third/mass/message'),
            },
            {
              path: 'statistics',
              props: true,
              component: load('third/mass/statistics'),
            },
          ],
        },
        {
          path: ':id/autoReply',
          props: true,
          redirect: ':id/autoReply/key',
          component: load('third/autoReply'),
          children: [
            {
              path: 'key',
              props: true,
              component: load('third/autoReply/key'),
            },
            {
              path: 'key/creat',
              props: true,
              component: load('third/autoReply/add'),
            },
            {
              path: 'key/edit',
              props: true,
              component: load('third/autoReply/add'),
            },
            {
              path: 'message',
              props: true,
              component: load('third/autoReply/message'),
            },
            {
              path: 'focus',
              props: true,
              component: load('third/autoReply/focus'),
            },
          ],
        },
        {
          path: ':id/lib',
          props: true,
          redirect: ':id/lib/article',
          component: load('third/lib'),
          children: [
            {
              path: 'article',
              props: true,
              component: load('third/lib/article'),
            },
            {
              path: 'image',
              props: true,
              component: load('third/lib/image'),
            },
            {
              path: 'sound',
              props: true,
              component: load('third/lib/sound'),
            },
            {
              path: 'video',
              props: true,
              component: load('third/lib/video'),
            },
          ],
        },
        {
          path: ':id/channel',
          props: true,
          redirect: ':id/channel/create',
          component: load('third/channel'),
          children: [
            {
              path: 'create',
              props: true,
              component: load('third/channel/create'),
            },
            {
              path: 'edit',
              props: true,
              component: load('third/channel/edit'),
            },
            {
              path: 'refer',
              props: true,
              component: load('third/channel/refer'),
            },
            {
              path: 'refer/details',
              props: true,
              component: load('third/channel/details'),
            },
            {
              path: 'refer/detail',
              props: true,
              component: load('third/channel/detail'),
            },
          ],
        },
        {
          path: ':id/pay',
          props: true,
          redirect: ':id/pay/index',
          component: load('third/pay'),
          children: [
            {
              path: 'index',
              props: true,
              component: load('third/pay/index'),
            },
            {
              path: 'detail',
              props: true,
              component: load('third/pay/detail'),
            },
            {
              path: 'config',
              props: true,
              component: load('third/pay/config'),
            },
          ],
        },
        {
          path: ':id/usermana',
          props: true,
          redirect: ':id/usermana/index',
          component: load('third/userMana'),
          children: [
            {
              path: 'index',
              props: true,
              component: load('third/userMana/index'),
            },
            {
              path: 'takeoff',
              props: true,
              component: load('third/userMana/takeoff'),
            },
          ],
        },
      ],
    },
  ],
});

function except(modules, path) {
  let inPath = false;
  modules.map(n => {
    if (path.split('/')[1] == n) inPath = true;
  });

  return inPath;
}

Router.beforeEach((to, from, next) => {
  let common = ['login'];
  if (!store.get('token') && !except(common, to.path))
    return next({
      name: 'login',
    });

  if (to.path == '/')
    return next({
      name: 'center',
    });

  next();
});

export default Router;
